import cn from "classnames";
import Image from "next/image";
import Link from "next/link";
import { memo } from "react";

import luxLogoWhite from "@images/svg/logo-white.svg";
import Divider from "@ui-kit/Divider/Divider";

import s from "./AdvBannerBlock.layout.module.scss";

const AdvBannerBlockLayout = ({
  className,
  items,
  isEditMode,
  isWidgetEditing,
  isWidget,
  cursorNotice,
  collectionType,
  handleClickToEdit,
}) => {
  const itemsToShow = items.filter((item) => item.isShow);

  const isEmpty = !itemsToShow.length;

  if (!isEditMode && isEmpty) {
    return null;
  }

  const getRandomObject = (arr) => {
    const randomIndex = Math.floor(Math.random() * arr.length);
    return arr[randomIndex];
  };

  const banner = getRandomObject(itemsToShow) || {};

  const Tag = isEditMode ? "div" : Link;
  return (
    <Tag
      href={banner?.slug || "/"}
      className={cn(s.advBanner, isEmpty && s.empty, className)}
      {...(isEditMode && !(!isWidgetEditing && isWidget)
        ? {
            "data-cursor-notice": cursorNotice,
            "data-collection-type": collectionType,
            onClick: handleClickToEdit,
          }
        : {})}
    >
      <div className={s.image}>
        {!isEmpty && (
          <Image
            src={banner.image}
            alt={banner.alt}
            fill
            style={{
              objectFit: "cover",
              objectPosition: "center",
            }}
            // sizes="372px"
            // quality={100}
          />
        )}
      </div>
      <div className={s.logo}>
        <Image
          src={luxLogoWhite}
          alt="luxexpress logo"
          width={87}
          height={24}
        />
      </div>
      {!isEmpty && (
        <div className={s.description}>
          <div className={s.title}>{banner.title}</div>
          <div className={s.text}>{banner.subTitle}</div>
        </div>
      )}

      <Divider height={3} absolute />
    </Tag>
  );
};

export default memo(AdvBannerBlockLayout);
